import * as Yup from 'yup';

export const extendImplementationTimeBaseSchema = Yup.object().shape({
  extendDate: Yup.date()
    .nullable()
    .when('endDate', {
      is: (value) => value,
      then: Yup.date()
        .test(
          'isRequired',
          'extendImplementationTime.validationErrors.extendDateMustBeAfterEndDate',
          (date, context) => {
            const { endDate } = context.parent; // Access endDate from the context
            if (!date || !endDate) return false; // Ensure both dates are present
            return new Date(date) > new Date(endDate); // Check if extendDate is after endDate
          }
        )
        .nullable(),
    })
    .required('extendImplementationTime.validationErrors.extendDateRequired'),
  reason: Yup.string().required('extendImplementationTime.validationErrors.reasonRequired'),
});

export const extendImplementationTimeCreateSchema = Yup.object().shape({
  ...extendImplementationTimeBaseSchema.fields,
  decisionFile: Yup.mixed()
    .test('isRequired', 'formControl.validation.inputFile', (file) => {
      if (file) return true;
      return false;
    })
    .nullable(),
});

export const extendImplementationTimeUpdateSchema = Yup.object().shape({
  ...extendImplementationTimeBaseSchema.fields,
  decisionFile: Yup.mixed().when('fileUrl', {
    is: (value) => !value,
    then: Yup.mixed().test('isRequired', 'formControl.validation.inputFile', (file) => {
      if (file) return true;
      return false;
    }),
  }),
});
